import {useState, useEffect, useCallback} from 'react';
import {useLocation, useParams} from 'react-router-dom';
import Collapse from '@mui/material/Collapse';

import {usePathname} from 'src/routes/hooks';
import {useActiveLink} from 'src/routes/hooks/use-active-link';

import NavItem from './nav-item';
import {NavListProps, NavSubListProps} from '../types';
import {
  BASE_DATA_GRID_ROW,
  BASE_LEGACY_APP,
  BASE_MENU_ITEM,
  BASE_RECORD_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  BASE_ROUTE_SUB_MODULE,
  BASE_SPECIMEN_NUMBER,
  BASE_SPECIMEN_NUMBER_ID,
  BASE_SPECIMEN_TYPE,
  BASE_UNIQUE_ID,
  IS_FROM_EPIC,
  IS_FROM_ATHENA,
  MODE,
  PARAMS_KEY,
  BASE_ACCESSION_NUMBER
} from 'src/routes/BaseRoute';
import EncryptUtils from 'src/utils/EncryptUtils';
// import {CountBadge} from '@modules/home/main/sub-modules-menu/sub-modules-menu-list/SubModulesMenuListStyle';
import FormConstants from '@shared/constants/FormConstants';
import AuthUtils from 'src/utils/AuthUtils';

// ----------------------------------------------------------------------

export default function SubModuleNavList({
  data,
  depth,
  slotProps,
  url,
  subListPath,
  // renderCountBadge,
  filtersData,
  menuListData,
  setVisitDetails
}: NavListProps) {
  const pathname = usePathname();
  const location = useLocation();
  const params: any = useParams();

  const getLocalStorageData = AuthUtils.getSelectedCheckBoxData();

  const recordId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );

  const legacyApp = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_LEGACY_APP
  );

  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_ID
  );

  const isFromEpic = EncryptUtils.getDecryptedData(
    location?.search,
    IS_FROM_EPIC
  );

  const isFromAthena = EncryptUtils.getDecryptedData(
    location?.search,
    IS_FROM_ATHENA
  );

  const specimen_number = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_SPECIMEN_NUMBER
  );

  const specimen_number_id = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_SPECIMEN_NUMBER_ID
  );
 const accessionNumber = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_ACCESSION_NUMBER
  );
  const specimen_type = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_SPECIMEN_TYPE
  );

  const menuItem = new URLSearchParams(location?.search).get(BASE_MENU_ITEM);

  const mode = EncryptUtils.getDecryptedData(location?.search, MODE);

  const visitDetails = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_DATA_GRID_ROW
  );

  let surgicalVisitDetails;

  if (params?.module_name === FormConstants.MODULE.SURGICAL) {
    if (
      params?.submodule_name === FormConstants.SUB_MODULE.VISITS ||
      params?.submodule_name === FormConstants.SUB_MODULE.CLINICAL_LOG ||
      params?.submodule_name ===
        FormConstants.SUB_MODULE.IMPLANT_AND_SUPPLIES ||
      params?.submodule_name === FormConstants.SUB_MODULE.BILLING ||
      params?.submodule_name === FormConstants.SUB_MODULE.ACCOUNT
    ) {
      surgicalVisitDetails = visitDetails;
    } else {
      surgicalVisitDetails = undefined;
    }
  }
  setVisitDetails(surgicalVisitDetails);

  const paramsKey = EncryptUtils.setEncryptedParams({
    [BASE_RECORD_ID]: recordId,
    [BASE_LEGACY_APP]: legacyApp,
    [BASE_UNIQUE_ID]: uniqueId,
    [IS_FROM_EPIC]: isFromEpic,
    [IS_FROM_ATHENA]: isFromAthena,
    [MODE]: mode,
    [BASE_SPECIMEN_NUMBER]: specimen_number,
    [BASE_SPECIMEN_NUMBER_ID]: specimen_number_id,
    [BASE_ACCESSION_NUMBER]:accessionNumber,
    [BASE_SPECIMEN_TYPE]: specimen_type,
    [BASE_DATA_GRID_ROW]: surgicalVisitDetails
  });

  let submoduleurl = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${params?.module_name}/${BASE_ROUTE_SUB_MODULE}/${data.url}?${PARAMS_KEY}=${paramsKey}`;

  if (menuItem) {
    submoduleurl += `&${BASE_MENU_ITEM}=${menuItem}`;
  }

  const isActive =
    location.pathname ===
    `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${params?.module_name}/${BASE_ROUTE_SUB_MODULE}/${subListPath}`;

  const activeLink = useActiveLink(
    `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${params?.module_name}/${BASE_ROUTE_SUB_MODULE}/${data.url}`,
    !!data?.listMenuItems && data?.listMenuItems?.length > 0
  );

  const active = subListPath && url ? isActive : activeLink;

  const [openMenu, setOpenMenu] = useState(active);

  const handleCloseMenu = useCallback(() => {
    setOpenMenu(false);
  }, []);

  useEffect(() => {
    if (!active) {
      handleCloseMenu();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const handleToggleMenu = useCallback(() => {
    if (data.listMenuItems && data?.listMenuItems?.length > 0) {
      setOpenMenu(prev => !prev);
    }
  }, [data.listMenuItems]);
  const encounterIsBH = localStorage.getItem('encounterIsBH');
  const renderCountBadge = (countItem: any) => {
    return menuListData?.[countItem.url]?.count > 99
      ? (countItem.url === FormConstants.SUB_MODULE.ENCOUNTERS ||
          countItem.url === FormConstants.SUB_MODULE.ACCOUNTS) &&
        ((getLocalStorageData &&
          JSON.parse(getLocalStorageData)?.length >= 0) ||
          encounterIsBH === 'false')
        ? `${encounterIsBH === 'false' ? 0 : filtersData}/
            ${99}+
          `
        : `
                      ${99}+
                    `
      : (countItem.url === FormConstants.SUB_MODULE.ENCOUNTERS ||
            countItem.url === FormConstants.SUB_MODULE.ACCOUNTS) &&
          ((getLocalStorageData &&
            JSON.parse(getLocalStorageData)?.length >= 0) ||
            encounterIsBH === 'false')
        ? `${encounterIsBH === 'false' ? 0 : filtersData}/${menuListData?.[countItem.url]?.count || 0}`
        : menuListData?.[countItem.url]?.count || 0;
  };

  return (
    <>
      <NavItem
        open={openMenu}
        onClick={handleToggleMenu}
        //
        name={data.name}
        count={data.show_count && renderCountBadge && renderCountBadge(data)}
        show_count={data.show_count}
        menuListData={menuListData}
        url={submoduleurl}
        mainUrl={data.url}
        icon={data.icon}
        info={data.info}
        roles={data.roles}
        caption={data.caption}
        disabled={data.disabled}
        //
        depth={depth}
        hasChild={data.hasListMenuItems}
        externalLink={data.url.includes('http')}
        currentRole={slotProps?.currentRole}
        //
        active={active}
        className={active ? 'active' : ''}
        sx={{
          mb: `${slotProps?.gap}px`,
          ...(depth === 1 ? slotProps?.rootItem : slotProps?.subItem)
        }}
        title={undefined}
        path={''}
      />

      {!!data?.listMenuItems && data?.listMenuItems?.length > 0 && (
        <Collapse in={openMenu} unmountOnExit>
          <NavSubList
            data={data.listMenuItems}
            depth={depth}
            slotProps={slotProps}
            url={data.url}
          />
        </Collapse>
      )}
    </>
  );
}

// ----------------------------------------------------------------------

function NavSubList({data, depth, slotProps, url}: NavSubListProps) {
  return (
    <>
      {data.map(list => (
        <SubModuleNavList
          key={list.name}
          data={list}
          depth={depth + 1}
          slotProps={slotProps}
          url={list.url}
          subListPath={url}
        />
      ))}
    </>
  );
}
